import React from 'react'
import {
  Box,
  Typography,
  Container,
  Grid,
  makeStyles,
  Link,
} from '@material-ui/core'
import { FaTwitter } from 'react-icons/fa'

import { RiSendPlaneFill } from 'react-icons/ri'
import { AiOutlineInstagram } from 'react-icons/ai'

const useStyles = makeStyles((theme) => ({
  boxbg: {
    '& h6': {
      fontSize: '30px',
      fontWeight: '600',
      color: '#fff',
      marginTop: '15px',
      marginBottom: '15px',
    },
  },
  frame: {
    position: 'relative',
  },
  imgset: {
    width: '100%',
  },
  next: {
    position: 'absolute',
    top: '6%',
    left: '6%',
    width: '88%',
    right: '0%',
  },
}))

function HelpCenterCard(props) {
  const classes = useStyles()
  const { data } = props
  return (
    <Box>
      <Box className={classes.boxbg}>
        <Box className={classes.frame}>
          <img src={data.img1} width="100%" alt="" className={classes.imgset} />
          <img src={data.img2} width="100%" alt="" className={classes.next} />
        </Box>

        <Box textAlign="center">
          <Typography variant="h6">{data.text1}</Typography>
        </Box>
        <Box
          pb={4}
          display="flex"
          justifyContent="space-evenly"
          alignItems="center"
          style={{ width: '100%', maxWidth: '169px', margin: '0 auto' }}
        >
          <Link href="https://twitter.com/" target="_blank">
            <FaTwitter style={{ fontSize: '20px', color: '#fff' }} />
          </Link>
          <Link href="https://web.telegram.org/z/" target="_blank">
            <RiSendPlaneFill style={{ fontSize: '22px', color: '#fff' }} />
          </Link>
          <Link href="https://www.instagram.com/" target="_blank">
            <AiOutlineInstagram style={{ fontSize: '22px', color: '#fff' }} />
          </Link>
        </Box>
      </Box>
    </Box>
  )
}

export default HelpCenterCard
